import Carat from './Carat';

export default Carat;
